import type { RoadmapNode } from "../api/roadmap-service";
import type { LessonStatus } from "../api/user-progress-service";

/** The Lesson Status of every lesson the user started, across all courses of a roadmap. */
export type LessonStatuses = Map<string, LessonStatus>;

export type StationProgress = {
    lessons: number;
    /** Lessons with at least their first Verification Session passed. */
    verified: number;
    finished: number;
};

/** The courses a part of the roadmap draws lessons from, so their progress can be loaded. */
export function courseIdsOf(node: RoadmapNode): string[] {
    const own = node.courseId ? [ node.courseId ] : [];

    return [ ...new Set(own.concat(node.children.flatMap(courseIdsOf))) ];
}

function lessonIdsOf(node: RoadmapNode): string[] {
    const own = node.kind === 'LESSON' && node.id ? [ node.id ] : [];

    return own.concat(node.children.flatMap(lessonIdsOf));
}

export function stationProgress(node: RoadmapNode, statuses: LessonStatuses): StationProgress {
    const ids = [ ...new Set(lessonIdsOf(node)) ];
    const status = (id: string) => statuses.get(id) ?? 'NOT_STARTED';

    return {
        lessons: ids.length,
        verified: ids.filter((id) => status(id) !== 'NOT_STARTED').length,
        finished: ids.filter((id) => status(id) === 'FINISHED').length,
    };
}
